(function () {
  var qaDemoNewThemeConfig = function ($mdThemingProvider, $rootScope) {
    $mdThemingProvider.definePalette('qa-demo-new-primary', {
      '50': 'e5e7ed',
      '100': 'bdc4d1',
      '200': '919cb3',
      '300': '657495',
      '400': '44577e',
      '500': '233967',
      '600': '1f335f',
      '700': '1a2c54',
      '800': '15244a',
      '900': '0c1739',
      'A100': '7391ff',
      'A200': '4069ff',
      'A400': '0d41ff',
      'A700': '0034f2',
      'contrastDefaultColor': 'light',
      'contrastDarkColors': [
        '50',
        '100',
        '200',
        'A100'
      ],
      'contrastLightColors': [
        '300',
        '400',
        '500',
        '600',
        '700',
        '800',
        '900',
        'A200',
        'A400',
        'A700'
      ]
    });

    $mdThemingProvider.definePalette('qa-demo-new-accent', {
      '50': 'e4f0fe',
      '100': 'bbdafc',
      '200': '8ec2fa',
      '300': '61a9f8',
      '400': '3f96f7',
      '500': '1d84f5',
      '600': '1a7cf4',
      '700': '1571f2',
      '800': '1167f0',
      '900': '0a54ee',
      'A100': 'ffffff',
      'A200': 'e4ebff',
      'A400': 'b1c7ff',
      'A700': '97b4ff',
      'contrastDefaultColor': 'light',
      'contrastDarkColors': [
        '50',
        '100',
        '200',
        '300',
        '400',
        'A100',
        'A200',
        'A400',
        'A700'
      ],
      'contrastLightColors': [
        '500',
        '600',
        '700',
        '800',
        '900'
      ]
    });

    $mdThemingProvider.definePalette('qa-demo-new-warn', {
      '50': 'f9e9e9',
      '100': 'efc8c8',
      '200': 'e5a4a4',
      '300': 'da7f7f',
      '400': 'd26363',
      '500': 'ca4848',
      '600': 'c54141',
      '700': 'bd3838',
      '800': 'b73030',
      '900': 'ab2121',
      'A100': 'ffe5e5',
      'A200': 'ffb3b3',
      'A400': 'ff8080',
      'A700': 'ff6666',
      'contrastDefaultColor': 'light',
      'contrastDarkColors': [
        '50',
        '100',
        '200',
        '300',
        '400',
        'A100',
        'A200',
        'A400',
        'A700'
      ],
      'contrastLightColors': [
        '500',
        '600',
        '700',
        '800',
        '900'
      ]
    });

    $mdThemingProvider.theme('qa-demo-new')
      .primaryPalette('qa-demo-new-primary')
      .accentPalette('qa-demo-new-accent', { 'default': '500' })
      .warnPalette('qa-demo-new-warn', { 'default': '500' });
  };

  qaDemoNewThemeConfig.$inject = ['$mdThemingProvider'];
  angular.module('ecap').config(qaDemoNewThemeConfig);

  var qaDemoNewThemeRun = function ($rootScope) {
    if (!$rootScope.$themes) {
      $rootScope.$themes = {};
    }
    $rootScope.$themes['qa-demo-new'] = {
      primaryColor: '#233967',
      accentColor: '#1d84f5'
    };
  };

  qaDemoNewThemeRun.$inject = ['$rootScope'];
  angular.module('ecap').run(qaDemoNewThemeRun);
})();